// src/redux/reducers/stockReducer.js
import {
  FETCH_POLYGON_STOCK_DATA_REQUEST,
  FETCH_POLYGON_STOCK_DATA_SUCCESS,
  FETCH_POLYGON_STOCK_DATA_FAILURE,
  GET_DIVIDENDS_DATA,
  GET_FINANCIALS_DATA,
  GET_RELATED_COMPANIES_DATA,
  GET_TICKER_DETAILS_DATA,
  GET_TICKER_EVENTS_DATA
} from './polygonActions';

const initialState = {
  loading: false,
  data: {},                  // open-close
  dividends: null,
  financials: null,
  relatedCompanies: null,
  tickerDetails: null,
  tickerEvents: null,
  error: null,
};

export const polygonstockReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POLYGON_STOCK_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POLYGON_STOCK_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case FETCH_POLYGON_STOCK_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_DIVIDENDS_DATA:
      return {
        ...state,
        dividends: action.payload,
      };

    case GET_FINANCIALS_DATA:
      return {
        ...state,
        financials: {
          ...(state.financials || {}),
          [action.payload.ticker]: action.payload.data,
        },
      };


    case GET_RELATED_COMPANIES_DATA:
      return {
        ...state,
        relatedCompanies: action.payload,
      };

    case GET_TICKER_DETAILS_DATA:
      return {
        ...state,
        tickerDetails: action.payload,
      };

    case GET_TICKER_EVENTS_DATA:
      return {
        ...state,
        tickerEvents: action.payload,
      };

    default:
      return state;
  }
};
